import { render, staticRenderFns } from "./ChartPieIcon.vue?vue&type=template&id=b19dac8e&"
import script from "./ChartPieIcon.vue?vue&type=script&lang=js&"
export * from "./ChartPieIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports